import { render, staticRenderFns } from "./AllergensViewer.vue?vue&type=template&id=1757a108&scoped=true"
import script from "./AllergensViewer.vue?vue&type=script&lang=js"
export * from "./AllergensViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1757a108",
  null
  
)

export default component.exports